import { reactive, getCurrentInstance } from 'vue';
import { getLanguageType } from '@/assets/js/i18n';
import to from 'await-to-js';
import { loaderFactories } from '@rebuild/utils/modules';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';
import { useStore } from '@/utils/vue-api';

export function useModuleData() {
	const { proxy } = getCurrentInstance();
	const store = useStore();

	const getCommonContext = () => {
		const storeId = resolveStoreId();
		const pageId = resolvePageId();
		const fullCode = store.getters.getIrFullCode;
		const [market, code] = store.getters.getIrMarketAndCode;
		return {
			storeId,
			pageId,
			languageType: getLanguageType(),
			fullCode: fullCode,
			code: code,
			market: market
		};
	};
	const context = getCommonContext(); // 自动注入全局上下文参数
	const state = reactive({});

	for (const [key, createLoader] of Object.entries(loaderFactories)) {
		// loader 是一个函数：payload => Promise
		const loader = createLoader(context);

		const entry = {
			data: null,
			loading: true,
			empty: false,
			error: null,
			refresh: async (payload = {}) => {
				entry.loading = true;
				entry.empty = false;
				entry.error = null;

				const [err, res] = await to(loader(payload));
				if (err) {
					entry.empty = true;
					entry.error = err;
				} else {
					entry.data = res;
				}

				entry.loading = false;
			}
		};

		proxy.$set(state, key, entry); // 确保响应式地添加属性
	}

	return state;
}
